

import React, { memo } from 'react';
import cx from 'classnames';










const IFRAME_DEFAULT_STYLE = {
  border: 0
};
const IFRAME_DEFAULT_FRAME_BORDER = 0;
const IFRAME_DEFAULT_WIDTH = '100%';
const IFRAME_DEFAULT_HEIGHT = '100%';

const IFrame = (props) => {
  const {
    url,
    width,
    height,
    className,
    hasScrolling = true,
    shouldAllowFullScreen
  } = props;

  const scrolling = hasScrolling ? undefined : 'no';

  return (
    // eslint-disable-next-line jsx-a11y/iframe-has-title
    <iframe
      className={cx('iframe', className)}
      src={url}
      style={IFRAME_DEFAULT_STYLE}
      frameBorder={IFRAME_DEFAULT_FRAME_BORDER}
      width={width || IFRAME_DEFAULT_WIDTH}
      height={height || IFRAME_DEFAULT_HEIGHT}
      scrolling={scrolling}
      // eslint-disable-next-line
      allowtransparency="allowtransparency"
      allowFullScreen={shouldAllowFullScreen} />);


};

export default memo(IFrame);